/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $BoosterCountConfig = {
    properties: {
        GOAL_KING: {
            type: 'number',
            isRequired: true,
        },
        CAPTAIN: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
